import { makeStyles } from '@mui/styles';

const useGenericStyles = makeStyles(() => ({
  container: {
    backgroundColor: 'background.default',
    minHeight: '100%',
    padding: '30px',
  },
  headerHeading: {
    fontSize: 22,
    fontWeight: 600,
    color: '#27272E',
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
  },
  smallHeading: {
    fontSize: 14,
    fontWeight: 600,
  },
  description: {
    fontSize: 14,
    fontWeight: 400,
    color: '#425466',
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: 500,
    color: '#212636',
    lineHeight: '150%',
    letterSpacing: '0px',
  },
  errorLabel: {
    color: '#FF0000',
  },
  button: {
    padding: '6px 16px',
    fontSize: 12,
    fontWeight: 600,
  },
  textField: {
    borderRadius: '5px',
    height: 40,
  },

  inputField: {
    marginTop: '3px',
    borderRadius: '8px',
    height: '42px',
    fontSize: 14,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    transition: 'all 0.3s ease',
    boxShadow: '0px 1px 2px 0px #00000014',
    border: '1px solid #DCDFE4',
    backgroundColor: '#FFFFFF',

    '&:hover': {
      borderColor: '#D1D5DB',
      backgroundColor: '#F9FAFB',
    },

    '&.Mui-focused': {
      borderColor: '#2196F3',
      backgroundColor: '#FFFFFF',
      boxShadow: '0 0 0 4px rgba(33, 150, 243, 0.1)',
    },

    '&.Mui-error': {
      borderColor: '#FF0000',
      backgroundColor: '#FEF2F2',

      '&:hover': {
        borderColor: '#FF0000',
      },

      '&.Mui-focused': {
        borderColor: '#FF0000',
        boxShadow: '0 0 0 4px rgba(255, 0, 0, 0.15)',
      },
    },

    '& fieldset': {
      border: 'none',
    },

    '&:hover fieldset': {
      border: 'none',
    },

    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },
  autoComplete: {
    marginTop: '10px',
    borderRadius: '6px',
    height: '36px',
    boxShadow:
      '0px 0px 1px 0px rgba(50, 50, 71, 0.2), 0px 1px 2px 0px rgba(50, 50, 71, 0.08)',
    '& .MuiOutlinedInput-root': {
      height: 36,
      paddingTop: 0,
      '& .MuiChip-root': {
        height: 28,
        '& span': {
          fontSize: '10px',
          paddingLeft: '6px',
          paddingRight: '6px',
          fontWeight: 500,
          color: '#231F20',
        },
      },
      '& .MuiChip-deleteIcon': {
        fontSize: '18px',
      },
      '& input': {
        padding: 0,
      },
    },
  },
  placeholder: {
    '&::placeholder': {
      color: '#8A94A6', // Placeholder color
      fontSize: 14,
      lineHeight: '24px',
      letterSpacing: '0.15px',
    },
  },
  instructions: {
    fontSize: 12,
    fontWeight: 400,
  },
}));

export default useGenericStyles;
